// AI-ASSISTED: generated with claude-code on 2026-08-19, reviewed by Yoann Hertienne
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isKubernetesAvailable } from '@backstage/plugin-kubernetes';

export { DeployedVersionsCard } from './DeployedVersionsCard';

// US12 (DPT-508) — the per-cluster deployed-version summary lives on its own
// entity tab, adjacent to the stock Kubernetes tab. It can't be rendered inside
// that tab: the plugin's Kubernetes content is a routable extension that the new
// frontend system requires to be mounted directly by the plugin, so wrapping it
// throws "Routable extension component … was not discovered". `isKubernetesAvailable`
// scopes the tab to components that actually carry a Kubernetes annotation.
// `group: 'deployment'` matches the Kubernetes tab's own group so the two render
// side by side in the tab strip.
const deployedVersionsTab = EntityContentBlueprint.make({
  name: 'deployed-versions',
  params: {
    path: 'deployed-versions',
    title: 'Deployed versions',
    group: 'deployment',
    filter: isKubernetesAvailable,
    loader: async () => {
      const { DeployedVersionsContent } = await import('./DeployedVersionsContent');
      return <DeployedVersionsContent />;
    },
  },
});

export const deployedVersionsTabModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [deployedVersionsTab],
});
